import SessionEventProto from "../session-event-proto"

export default class SessionEventReset extends SessionEventProto {
    process() {

        if (this.isDifferentCompany()) return false;

        gd.session.events.reset(this.data);
    }
}